<div class="relative font-inter">
  <div *ngIf="!manual" class="relative">
    <p class="font-inter text-[#042F2E] text-sm mb-1">
      {{ addressLabel }}
      <span *ngIf="showRequiredIndicator" class="text-red-500">*</span>
    </p>
    <input
      id="dawa-address-search"
      type="search"
      [(ngModel)]="searchText"
      role="combobox"
      aria-autocomplete="list"
      aria-controls="dawa-address-suggestions"
      [attr.aria-expanded]="isOpen"
      [ngClass]="{ 'border-red-500': errorInAddress }"
      (focus)="onSearchFocus()"
      (ngModelChange)="onSearchChange($event)"
      autocomplete="off"
      class="inline-flex w-full items-center gap-x-2 whitespace-nowrap rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-[#1F2937] shadow-sm hover:bg-gray-50 focus:border-[#1FAD96] focus:outline-none focus:ring-2 focus:ring-teal-500/25 disabled:pointer-events-none disabled:opacity-50"
    />

    <div
      id="dawa-address-suggestions"
      class="absolute z-50 mt-2 max-h-96 w-full overflow-y-auto rounded-md border bg-white px-2 py-2 font-semibold shadow-lg"
      role="listbox"
      *ngIf="isOpen && suggestions.length"
    >
      <button
        *ngFor="let suggestion of suggestions; let index = index"
        type="button"
        class="block w-full cursor-pointer rounded-md px-2 py-2 text-left text-sm hover:bg-[#F3F4F6]"
        [id]="'dawa-suggestion-' + index"
        role="option"
        [attr.aria-selected]="index === activeSuggestionIndex"
        [class.bg-gray-100]="index === activeSuggestionIndex"
        (mousedown)="$event.preventDefault()"
        (click)="chooseSuggestion(suggestion)"
      >
        {{ suggestion.tekst }}
      </button>
    </div>
  </div>

  <div
    class="m-0 grid gap-x-6 gap-y-4 overflow-hidden transition-[grid-template-rows,opacity] duration-500 ease-in-out"
    [style.gridTemplateRows]="manual ? '1fr' : '0fr'"
    [class.opacity-100]="manual"
    [class.opacity-0]="!manual"
    [class.max-h-0]="!manual"
  >
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
      <app-input
        (ngModelChange)="manualFieldChange('customerStreet')"
        class="component-container"
        [(ngModel)]="manualAddress.customerStreet"
        [errorInInput]="errorInCustomerStreet"
        [isRequired]="true"
        [title]="'Vejnavn'"
      ></app-input>

      <app-input
        (ngModelChange)="manualFieldChange('customerBuildingNumber')"
        class="component-container"
        [(ngModel)]="manualAddress.customerBuildingNumber"
        [errorInInput]="errorInCustomerBuildingNumber"
        [isRequired]="true"
        [title]="'Hus nummer'"
      ></app-input>
    </div>

    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
      <app-input
        (ngModelChange)="manualFieldChange('customerDoor')"
        class="component-container"
        [(ngModel)]="manualAddress.customerDoor"
        [errorInInput]="errorInCustomerDoor"
        [isRequired]="false"
        [title]="'Dør'"
      ></app-input>

      <app-input
        (ngModelChange)="manualFieldChange('customerFloor')"
        class="component-container"
        [(ngModel)]="manualAddress.customerFloor"
        [errorInInput]="errorInCustomerFloor"
        [isRequired]="false"
        [title]="'Etage'"
      ></app-input>
    </div>

    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
      <app-input
        (ngModelChange)="manualFieldChange('customerCity')"
        class="component-container"
        [(ngModel)]="manualAddress.customerCity"
        [errorInInput]="errorInCustomerCity"
        [isRequired]="true"
        [title]="'Bynavn'"
      ></app-input>

      <app-input
        (ngModelChange)="manualFieldChange('customerAdditionalCity')"
        class="component-container"
        [(ngModel)]="manualAddress.customerAdditionalCity"
        [errorInInput]="errorInCustomerAdditionalCity"
        [isRequired]="false"
        [title]="'Supplerende bynavn'"
      ></app-input>
    </div>

    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
      <app-input
        (ngModelChange)="manualFieldChange('customerPostCode')"
        class="component-container"
        [(ngModel)]="manualAddress.customerPostCode"
        [errorInInput]="errorInCustomerPostCode"
        [isRequired]="true"
        [title]="'Postnummer'"
      ></app-input>
    </div>
  </div>

  <button
    (click)="toggleManual()"
    type="button"
    class="py-1 inline-flex items-center gap-x-2 text-xs font-medium rounded-lg border border-transparent text-teal-500 hover:text-teal-600 disabled:opacity-50 disabled:pointer-events-none"
  >
    <span *ngIf="!manual">Indtast manuelt</span>
    <span *ngIf="manual">Annuller</span>
  </button>
</div>
